// extracted by mini-css-extract-plugin
export default {"question":"KWZpv","question__container":"qxWcj","question__content":"Yu51h","question__headline":"EPKPK","question__description":"fxa02","question__link":"QIAT4"};